<template>
  <StepContainer
    v-loading="isLoading"
    :title="$t('APPS.DRAFT.STEPS.APP_MEDIA')"
  >
    <UploaderSection
      :title="$t('APPS.DRAFT.STEPS.APP_MEDIA.APP_ICON')"
      :limits="iconLimits"
    >
      <UploadDraftAppIcon
        class="app-images-step__section"
        :icon="draftApp.icon"
      />
    </UploaderSection>

    <UploaderSection :title="$t('APP.MEDIA.SCREENSHOTS')">
      <UploadDraftAppScreenshots
        class="app-images-step__section"
        :screenshots.sync="screenshots"
      />
    </UploaderSection>

    <!-- <UploaderSection
      :title="$t('APP.MEDIA.PROMOTION_SCREENSHOTS')"
      :description="
        $t('APPS.DRAFT.STEPS.APP_MEDIA.PROMOTION_SCREENSHOTS.DESCRIPTION')
      "
      :limits="promoScreenshotLimits"
    >
      <UploadDraftAppPromotionScreenshots
        class="app-images-step__section"
        :screenshots.sync="promotionScreenshots"
      />
    </UploaderSection> -->

    <UploaderSection
      :title="$t('APP.MEDIA.VIDEO_SHOTS')"
      :description="$t('APP.MEDIA.VIDEO_SHOTS_DESC')"
    >
      <AppVideoshotsForm
        :videoshot-fa.sync="videoshotFa"
        :videoshot-en.sync="videoshotEn"
        :errors="fieldErrors"
      />
    </UploaderSection>

    <StepControllers slot="actions" @change-step="goToStep" />
  </StepContainer>
</template>

<script>
import StepContainer from '../common/StepContainer';
import StepControllers from '../common/StepControllers';
import UploadDraftAppIcon from './UploadDraftAppIcon';
import UploadDraftAppScreenshots from './UploadDraftAppScreenshots';
import { mapActions, mapGetters } from 'vuex';
import { CHANGE_DRAFT_APP_STATE, DRAFT_APP } from '@/store/types';
import UploaderSection from './UploaderSection';
import AppVideoshotsForm from './AppVideoshotsForm';

export default {
  name: 'AppMediaStep',
  components: {
    StepContainer,
    StepControllers,
    UploadDraftAppIcon,
    UploadDraftAppScreenshots,
    UploaderSection,
    AppVideoshotsForm,
  },
  inject: ['stepperController'],
  data() {
    return {
      isLoading: false,
      fieldErrors: {},
      screenshots: [],
      promotionScreenshots: [],
      videoshotEn: '',
      videoshotFa: '',
    };
  },
  computed: {
    ...mapGetters({ draftApp: DRAFT_APP }),
    iconLimits() {
      return [
        { name: this.$t('APP.MEDIA.FILE_TYPE'), value: 'PNG' },
        { name: this.$t('APP.MEDIA.ASPECT_RATIO'), value: '1:1' },
        { name: this.$t('APP.MEDIA.MIN_SIZE'), value: '512px*512px' },
        { name: this.$t('APP.MEDIA.MAX_FILE_SIZE'), value: '3MB' },
      ];
    },
    promoScreenshotLimits() {
      return [
        { name: this.$t('APP.MEDIA.FILE_TYPE'), value: 'JPG - PNG' },
        { name: this.$t('APP.MEDIA.MIN_WIDTH'), value: '1152px' },
        { name: this.$t('APP.MEDIA.MIN_HEIGHT'), value: '648px' },
        { name: this.$t('APP.MEDIA.ASPECT_RATIO'), value: '16:9' },
        { name: this.$t('APP.MEDIA.MAX_FILE_SIZE'), value: '1MB' },
      ];
    },
    isDataValid() {
      return true;
    },
  },
  watch: {
    draftApp: {
      immediate: true,
      handler(draftApp) {
        this.screenshots = [...draftApp.screenshots];
        this.promotionScreenshots = [...draftApp.promotionScreenshots];
        this.videoshotFa = draftApp.videoshotFa;
        this.videoshotEn = draftApp.videoshotEn;
      },
    },
  },
  created() {
    this.stepperController.onStepClick(this.goToStep);
  },
  beforeDestroy() {
    this.stepperController.removeOnStepClick(this.goToStep);
  },
  methods: {
    ...mapActions({ checkAndChangeStep: CHANGE_DRAFT_APP_STATE }),

    goToStep(step) {
      this.isLoading = true;
      this.fieldErrors = {};

      const data = {
        icon: this.draftApp.icon,
        screenshots: this.screenshots.map(item => item.token),
        promotionScreenshots: this.promotionScreenshots.map(item => item.token),
        videoshotFa: this.videoshotFa || null,
        videoshotEn: this.videoshotEn || null,
      };

      this.checkAndChangeStep({ to: step, data })
        .catch(({ message, errors = [], fieldErrors = {} }) => {
          this.$message.error(message);
          this.errors = errors;
          this.fieldErrors = fieldErrors;
        })
        .finally(() => (this.isLoading = false));
    },
  },
};
</script>
